import SvgIcon from '@mui/material/SvgIcon';

export default function EtransportIcon({ ...props }) {
  return (
    <SvgIcon viewBox="0 0 107 91" {...props}>
      <g transform="translate(0,91) scale(0.1,-0.1)" fill="currentColor" stroke="none">
        <path d="M551 809 c-127 -25 -253 -123 -325 -252 -41 -73 -43 -74 -110 -40 -35 18 -44 10 -72 -64 -20 -52 -22 -49 57 -76 l63 -22 13 -59 c29 -127 140 -203 286 -193 119 8 154 25 362 188 64 49 107 75 150 88 l60 19 3 67 3 68 -52 -6 c-85 -10 -153 -49 -313 -180 -146 -119 -280 -142 -356 -62 -30 32 -18 45 43 45 160 1 320 82 398 203 115 178 8 319 -210 276z m119 -151 c0 -48 -61 -113 -145 -155 -42 -21 -172 -50 -182 -40 -24 25 84 154 154 184 97 41 173 46 173 11z" />
      </g>
    </SvgIcon>
  );
}

export function EtransportManualIcon({ ...props }) {
  return (
    <SvgIcon viewBox="0 0 176 163" {...props}>
      <g transform="translate(0,163) scale(0.1,-0.1)" fill="currentColor" stroke="none">
        <path d="M737 1514 c-564 -126 -766 -796 -363 -1199 492 -492 1326 -63 1207 621 -69 392 -465 664 -844 578z m22 -576 c58 -164 108 -298 111 -298 3 0 53 134 112 298 l106 297 101 3 101 3 0 -406 0 -405 -77 0 -76 0 7 290 c3 159 9 298 13 307 4 13 3 15 -5 8 -9 -9 -107 -270 -195 -517 l-30 -88 -56 0 -56 0 -109 300 c-105 289 -127 341 -119 282 2 -15 7 -152 11 -305 l7 -277 -77 0 -78 0 0 405 0 406 102 -3 102 -3 105 -297z" />
      </g>
    </SvgIcon>
  );
}

export function EtransportAutomaticIcon({ ...props }) {
  return (
    <SvgIcon viewBox="0 0 193 187" {...props}>
      <g transform="translate(0,187) scale(0.1,-0.1)" fill="currentColor" stroke="none">
        <path d="M835 1781 c-389 -63 -681 -366 -727 -753 -50 -425 223 -817 647 -929 112 -29 298 -29 410 0 310 82 544 316 626 626 30 114 30 289 1 407 -76 309 -303 541 -614 628 -82 23 -262 34 -343 21z m340 -91 c274 -86 475 -292 547 -559 27 -103 30 -287 4 -386 -80 -315 -344 -551 -666 -595 -241 -33 -483 50 -661 229 -226 227 -292 576 -163 867 101 229 314 403 560 458 98 22 285 15 379 -14z" />
        <path d="M865 1478 c-11 -6 -21 -12 -22 -12 -2 -2 -313 -947 -313 -952 0 -2 31 -4 69 -4 58 0 71 3 75 18 3 9 23 77 46 150 l41 132 194 0 c126 0 196 -4 200 -11 4 -5 26 -72 49 -147 l43 -137 73 -3 c63 -3 72 -1 66 13 -3 9 -74 223 -157 476 -115 349 -156 463 -172 474 -26 18 -162 20 -192 3z m120 -110 c2 -7 32 -105 66 -218 34 -113 64 -211 67 -217 3 -10 -32 -13 -157 -13 -89 0 -161 4 -161 9 0 5 29 103 65 217 36 115 65 214 65 221 0 17 49 17 55 1z" />
      </g>
    </SvgIcon>
  );
}
